<template>
  <div class="qcStatistics">
    <div v-for="(item, index) in results" :key="index" class="p-b-10">
      <el-row>
        <el-col :span="24" class="d-f justify-b align-c p-lr-10">
          <section class="d-f align-c f-s-14">
            <div class="m-r-10">
              <span class="f-w-600 m-r-10">
                {{ item.taskType === 1 ? '主' : '' }}质控任务{{
                  index === 0 ? '' : index + 1
                }}
              </span>
              质控人：{{ getQcMan(item) }}
              <span :class="[item.newPerson == 2 ? 'c-409EFF' : '']">
                {{
                  index === 0
                    ? '（主质控）'
                    : item.newPerson == 2
                    ? '(新人)'
                    : ' &nbsp; &nbsp;'
                }}
              </span>
            </div>
            <span class="m-r-15">
              任务状态：
              <span v-if="item.status == -1">已取消</span>
              <span v-if="item.status == 0">未开始</span>
              <span v-if="item.status == 1">待领取</span>
              <span v-if="item.status == 2">进行中</span>
              <span v-if="item.status == 3">已提交</span>
            </span>
            <span class="m-r-15">
              提交人：{{ item.submitQcId }}（
              <span v-if="item.submitType == 1">主质控</span>
              <span v-if="item.submitType == 2">子质控</span>
              <span v-if="item.submitType == 3">pm</span>
              ）
            </span>
            <span class="m-r-15">
              提交时剩余未处理句子数：{{
                item.taskTjDto.underReviewNum || '暂无'
              }}
              <span v-if="item.taskTjDto.underReviewNum">
                （含审核中{{ item.taskTjDto.auditingNum }}句）
              </span>
            </span>
            <span>翻译进度：{{ item.finishWordCount }}/{{ item.wordNum }}</span>
          </section>
          <section>
            <el-tag
              size="small"
              class="f-w-400"
              v-if="
                item.taskTjDto.flowLevel == 3 ||
                item.taskTjDto.flowLevel == 4 ||
                item.taskTjDto.flowLevel == 5
              "
            >
              <span
                class="m-r-10"
                v-if="
                  item.taskTjDto.flowLevel == 3 || item.taskTjDto.flowLevel == 5
                "
              >
                未完成PE翻译任务：{{ item.taskTjDto.peNum || 0 }}
              </span>
              <span
                v-if="
                  item.taskTjDto.flowLevel == 4 || item.taskTjDto.flowLevel == 5
                "
              >
                未完成PE审核任务：{{ item.taskTjDto.peAuditNum || 0 }}
              </span>
            </el-tag>
          </section>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <avue-crud :option="rightOption" :data="item.list">
            <template slot="riskLevel" slot-scope="scope">
              <cellRiskLevel :riskLevel="scope.row.riskLevel"></cellRiskLevel>
            </template>
            <template slot="header">
              <div class="p-b-10">
                <span class="f-s-14 f-w-600">历史数据：</span>
                <span class="f-s-12">
                  （任务包在项目过程中会动态变化，此数据记录所有历史操作过的次数）
                </span>
              </div>
            </template>
          </avue-crud>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { qcTaskStatistics } from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import cellRiskLevel from '@/views/common/cellRiskLevel';
import { mapGetters, mapState } from 'vuex';

export default {
  props: ['orderId', 'flowId', 'staParams'],
  components: { cellRiskLevel },
  data() {
    return {
      leftOption: {
        card: true,
        refreshBtn: false,
        header: false, //表格头部中间菜单
        page: false,
        align: 'center',
        menu: false,
        addBtn: false, //新增按钮
        columnBtn: false,
        delBtn: false,
        editBtn: false,
        emptyText: '',
        column: [
          {
            width: 100,
            label: '风险等级',
            prop: 'riskLevel',
            slot: true,
          },
          {
            label: '包数',
            prop: 'totalNum',
          },
          {
            label: '句数',
            prop: 'totalSentecneNum',
          },
        ],
      },
      tjData: [],
      results: [],
      childOrderId: this.orderId,
      dataLevel: [],
      rightOption: {
        card: true,
        refreshBtn: false,
        header: false, //表格头部中间菜单
        page: false,
        addBtn: false, //新增按钮
        columnBtn: false,
        align: 'center',
        delBtn: false,
        editBtn: false,
        menu: false,
        emptyText: '',
        column: [
          {
            width: 100,
            label: '风险等级',
            prop: 'riskLevel',
            slot: true,
          },
          {
            label: '质控打回任务池（句数）',
            prop: 'returnNum',
          },
          {
            label: '质控修改/翻译（句数）',
            prop: 'modifyNum',
          },
          {
            width: 116,
            label: '已阅无误（句数）',
            prop: 'checkNum',
          },
          {
            width: 105,
            label: '未处理（句数）',
            prop: 'pendingNum',
          },
          {
            width: 116,
            label: '无需处理（句数）',
            prop: 'noDealNum',
          },
        ],
      },
    };
  },

  watch: {
    orderId: function (n, o) {
      this.childOrderId = n;
      this.init();
    },
  },

  computed: {
    ...mapGetters(['roles']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      roles: (state) => state.user.roles,
    }),

    taskStatus() {
      return this.results.some((item) => {
        return item.status == 1 && item.pid;
      });
    },

    isShowBtn() {
      let path = this.$route.path;
      if (path.indexOf('detail-qc') > 0) {
        return true;
      }
    },
  },

  methods: {
    getQcMan(item) {
      if (item.status === 2 || item.status === 3) {
        // return item.userWebVos[0].realname;
        return item.receiver;
      } else if (item.status === -1) {
        return '已取消  ';
      } else if (item.status === 1) {
        return '待领取  ';
      }
      return '';
    },

    init() {
      qcTaskStatistics({ orderId: this.childOrderId }).then((res) => {
        this.results = res.data.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.avue-header-font {
  font-size: 14px;
  font-weight: bold;
}
</style>
